import { MapMarkerClusterer } from './map-marker-clusterer.model';

export class AssignedStopMapMarkerCluster extends MapMarkerClusterer {}
